import React, { useState, useEffect } from "react";
import Button from "../../components/Button/Button";
import { FaSave, FaTimes } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { updateActorEvent } from "../../services/acteureventServices";
import { toast } from "react-toastify";

const NoteModal = ({ isOpen, onClose, actorEvent, fetchActors }) => {
  const [note, setNote] = useState("");
  const [observations, setObservations] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  // Remise à jour des champs quand on ouvre ou qu'on change d'acteur
  useEffect(() => {
    if (isOpen && actorEvent) {
      setNote(actorEvent.note || "");
      setObservations(actorEvent.observations || "");
    } else {
      setNote("");
      setObservations("");
    }
  }, [isOpen, actorEvent]);

  const handleSave = async (e) => {
    e?.preventDefault?.();
    if (!actorEvent) return;

    try {
      setIsSaving(true);
      await updateActorEvent(actorEvent.acteur_id, actorEvent.event_id, {
        note,
        observations,
      });
      toast.success("Informations mises à jour avec succès.");
      fetchActors?.(); // Rafraîchir la liste des acteurs si fourni
      onClose();
    } catch (error) {
      console.error(
        "Erreur lors de la mise à jour des informations de l'acteur",
        error
      );
      toast.error("Erreur lors de la mise à jour des informations de l'acteur.");
    } finally {
      setIsSaving(false);
    }
  };

  // Fermer en cliquant sur le fond (mais pas sur la boîte)
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
      onClick={handleBackdropClick}
    >
      <div
        className="modal-box bg-white dark:bg-slate-400 p-4 sm:p-6 rounded-2xl shadow-xl w-full max-w-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="mb-4 sm:mb-5">
          <h3 className="text-lg sm:text-xl font-bold uppercase px-3 py-2 text-center text-white bg-primary rounded-md shadow">
            Noter l&apos;acteur
          </h3>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-2 text-xs sm:text-sm">
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-slate-100 text-slate-800">
              Poste :
              <span className="font-semibold">
                {actorEvent?.poste || "Non renseigné"}
              </span>
            </span>
            {actorEvent?.acteurLabel && (
              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-blue-50 text-blue-800">
                Acteur :
                <span className="font-semibold">
                  {actorEvent.acteurLabel}
                </span>
              </span>
            )}
          </div>
        </div>

        <form onSubmit={handleSave}>
          {/* NOTE */}
          <div className="mb-4">
            <div className="flex items-center justify-between mb-1">
              <label className="block text-sm font-semibold">
                Note (optionnelle)
              </label>
              <span className="text-[11px] text-slate-500">
                ex : 1 à 5, A / B / C…
              </span>
            </div>
            <input
              type="text"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="input input-bordered w-full dark:text-black"
              placeholder="Saisir une note ou laisser vide"
            />
          </div>

          {/* OBSERVATIONS */}
          <div className="mb-3 sm:mb-4">
            <div className="flex items-center justify-between mb-1">
              <label className="block text-sm font-semibold">
                Observations (visibles dans le suivi)
              </label>
              <span className="text-[11px] text-slate-500">
                Comportement, points forts, axes de progrès…
              </span>
            </div>
            <div className="border border-slate-200 rounded-lg overflow-hidden bg-white">
              <ReactQuill
                value={observations}
                onChange={setObservations}
                theme="snow"
                className="quill-editor"
                style={{ height: 180 }}
              />
            </div>
          </div>

          {/* Boutons */}
          <div className="flex flex-col sm:flex-row justify-center gap-2 sm:gap-3 mt-5">
            <Button
              onClick={handleSave}
              type="submit"
              className="btn-primary flex items-center gap-2 justify-center min-w-[140px]"
              text={isSaving ? "Enregistrement..." : "Enregistrer"}
              icon={FaSave}
              disabled={isSaving || !actorEvent}
            />
            <Button
              onClick={onClose}
              type="button"
              className="btn-ghost flex items-center gap-2 justify-center min-w-[120px]"
              text="Fermer"
              icon={FaTimes}
              disabled={isSaving}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default NoteModal;
